// Sidebar icons - imported from SVG files
// Icons use currentColor to inherit color from parent

// Settings menu icons
import AccreditationsIcon from './accreditations.svg?react';
import AlgorithmIcon from './algorithm.svg?react';
import ArrowLeftIcon from './arrow-left.svg?react';
import BulkDataUploadIcon from './bulk-data-upload.svg?react';
import AttireIcon from './attire.svg?react';
import AutomationConfigIcon from './automation-config.svg?react';
import CancellationPolicyIcon from './cancellation-policy.svg?react';
import ChecklistsIcon from './checklists.svg?react';
import DemoUsersIcon from './demo-users.svg?react';
import DistrictsIcon from './districts.svg?react';
import EnterpriseOrganizationsIcon from './enterprise-organizations.svg?react';
import FlexAppOptionsIcon from './flex-app-options.svg?react';
import GuidesIcon from './guides.svg?react';
import HolidayPricingIcon from './holiday-pricing.svg?react';
import MarketsIcon from './markets.svg?react';
import OrganizationIcon from './organization.svg?react';
import PartnersIcon from './partners.svg?react';
import PayrollIcon from './payroll.svg?react';
import PositionAvailabilityIcon from './position-availability.svg?react';
import PositionsIcon from './positions.svg?react';
import RateCardsIcon from './rate-cards.svg?react';
import RateEngineIcon from './rate-engine.svg?react';
import RateSimulatorIcon from './rate-simulator.svg?react';
import PromoCodesIcon from './promo-codes.svg?react';
import ReferralsIcon from './referrals.svg?react';
import SectorsIcon from './sectors.svg?react';
import TermsAndPrivacyIcon from './terms-and-privacy.svg?react';

// Main menu icons
import AgenciesIcon from './agencies.svg?react';
import AngleDoubleLeftIcon from './angle-double-left.svg?react';
import AngleDoubleRightIcon from './angle-double-right.svg?react';
import ClientsIcon from './clients.svg?react';
import DashboardIcon from './dashboard.svg?react';
import JobsIcon from './jobs.svg?react';
import LeadsIcon from './leads.svg?react';
import SettingsIcon from './settings.svg?react';
import TimesheetsIcon from './timesheets.svg?react';
import UsersIcon from './users.svg?react';
import WorkforceIcon from './workforce.svg?react';

export {
  // Settings menu icons
  ArrowLeftIcon,
  // Main menu icons
  AngleDoubleLeftIcon,
  AngleDoubleRightIcon,
};

// Icon map for main menu lookup by key
export const menuIcons = {
  'dashboard/insights': DashboardIcon,
  leads: LeadsIcon,
  clients: ClientsIcon,
  workforce: WorkforceIcon,
  jobs: JobsIcon,
  sessions: JobsIcon,
  agencies: AgenciesIcon,
  timesheets: TimesheetsIcon,
  settings: SettingsIcon,
  agencyWorkers: WorkforceIcon,
};

// Icon map for settings menu lookup by key
export const settingsIcons = {
  accreditations: AccreditationsIcon,
  algorithm: AlgorithmIcon,
  attires: AttireIcon,
  automationConfig: AutomationConfigIcon,
  cancellationPolicy: CancellationPolicyIcon,
  checklists: ChecklistsIcon,
  dataUploads: BulkDataUploadIcon,
  clientFeedbackOptions: FlexAppOptionsIcon,
  demoUsers: DemoUsersIcon,
  districts: DistrictsIcon,
  enterprise_organizations: EnterpriseOrganizationsIcon,
  legalEntities: EnterpriseOrganizationsIcon,
  flexAppOptions: FlexAppOptionsIcon,
  holidayPricing: HolidayPricingIcon,
  markets: MarketsIcon,
  organization: OrganizationIcon,
  partners: PartnersIcon,
  payroll: PayrollIcon,
  positions: PositionsIcon,
  'pricing/rate-engine': RateEngineIcon,
  'pricing/rate-cards': RateCardsIcon,
  'pricing/rate-simulator': RateSimulatorIcon,
  'pricing/position-availability': PositionAvailabilityIcon,
  promoCodes: PromoCodesIcon,
  referrals: ReferralsIcon,
  sectors: SectorsIcon,
  termsAndPrivacy: TermsAndPrivacyIcon,
  users: UsersIcon,
  'user-guide': GuidesIcon,
};
